import { Box, Grid2, Tab } from "@mui/material";
import SearchedComponent from "../../components/SearchedComponent";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import SmallLoader from "../../components/SmallLoader";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import DataCorrectionsGrid from "../../components/DataCorrectionsGrid/DataCorrectionsGrid";
import { Home } from "@mui/icons-material";
import { getCorrectionGridDataService } from "../../services/dataCorrectionsService";
import { notifyError } from "../../utilities/helper";

const DataCorrections = () => {
  const [load, setLoad] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [tabValue, setTabValue] = useState("myQueue");
  const navigate = useNavigate();

  const roleId = localStorage.getItem("roleId");
  const cultureCode = localStorage.getItem("currentUserCultureCode");
  const access_token = localStorage.getItem("access_token");

  const debouncedSearch = useDebounceSearch(searchedValue, 500);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getGridDataForTab(pageSize, page, debouncedSearch, tabValue);
    }
  }, [page, pageSize, access_token, debouncedSearch, tabValue]);

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getGridDataForTab = async (
    pageSize,
    page,
    debouncedSearch = "",
    tab,
  ) => {
    setLoad(true);
    let correctionCode = "Q";
    if (tab === "pending") {
      correctionCode = "P";
    } else if (tab === "all") {
      correctionCode = "S";
    } else {
      correctionCode = "Q";
    }
    try {
      const res = await getCorrectionGridDataService(
        page + 1,
        pageSize,
        debouncedSearch,
        access_token,
        correctionCode,
        roleId,
        cultureCode,
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.message || "Something went wrong while fetching data");
      console.log(err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  return (
    <div className="content-body">
      <div className="home-container">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/data-correction">
            Data Correction
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
        <Link className="bread-crumbs-link home-inner-container">
          Set as Home Page
          <span>
            <Home
              sx={{
                fontSize: "20px",
              }}
            />
          </span>
        </Link>
      </div>

      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={4}>
          <p className="page-heading">Data Corrections</p>
        </Grid2>
        <Grid2 item md={8}>
          <div className="search-bar-container">
            <SearchedComponent
              searchedValue={searchedValue}
              handleSearch={handleSearch}
              placeholder={"Data Correction"}
            />
            <button
              className={"create-btn"}
              onClick={() => navigate("/add-data-corrections")}
            >
              Add New DCF
            </button>
          </div>
        </Grid2>
      </Grid2>

      {/* Tab Content */}

      <Box sx={{ width: "100%", mt: 2 }}>
        <TabContext value={tabValue}>
          {/* TABS HEADER */}
          <Box
            sx={{
              position: "relative",
              zIndex: 2, // tab must stay above panel
            }}
          >
            <TabList
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                minHeight: "48px",

                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 500,
                  px: 3,
                  minHeight: "48px",
                  border: "1px solid transparent",
                  borderBottom: "none",
                  borderRadius: "8px 8px 0 0",
                  backgroundColor: "transparent",
                  color: "text.secondary",
                  position: "relative",
                  zIndex: 1,
                },

                "& .Mui-selected": {
                  backgroundColor: "#FFFFFF",
                  color: "primary.main",
                  fontWeight: 600,
                  border: "1px solid #d0d7e2",
                  borderBottom: "none",
                  zIndex: 3,
                },
              }}
            >
              <Tab label="My Queue" value="myQueue" />
              <Tab label="Pending" value="pending" />
              <Tab label="All" value="all" />
            </TabList>
          </Box>

          {/* CONNECTED PANEL */}
          <Box
            sx={{
              border: "1px solid #d0d7e2",
              borderRadius: "0 8px 8px 8px",
              backgroundColor: "#ffffff",
              p: 3,

              marginTop: "-1px",

              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              position: "relative",
              zIndex: 1,
            }}
          >
            {load ? (
              <SmallLoader />
            ) : (
              <>
                {/* CARE GIVER MANAGAMENR */}
                <TabPanel value="myQueue" sx={{ p: 0 }}>
                  <DataCorrectionsGrid
                    page={page}
                    pageSize={pageSize}
                    rowData={rowData}
                    rowLength={rowLength}
                    setPage={setPage}
                    setPageSize={setPageSize}
                  />
                </TabPanel>
                <TabPanel value="pending" sx={{ p: 0 }}>
                  <DataCorrectionsGrid
                    page={page}
                    pageSize={pageSize}
                    rowData={rowData}
                    rowLength={rowLength}
                    setPage={setPage}
                    setPageSize={setPageSize}
                  />
                </TabPanel>
                <TabPanel value="all" sx={{ p: 0 }}>
                  <DataCorrectionsGrid
                    page={page}
                    pageSize={pageSize}
                    rowData={rowData}
                    rowLength={rowLength}
                    setPage={setPage}
                    setPageSize={setPageSize}
                  />
                </TabPanel>
              </>
            )}
          </Box>
        </TabContext>
      </Box>

      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/");
            }}
          >
            Back
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default DataCorrections;
